/**
 * Options for creating FindReplaceContext
 */
export interface FindReplaceHighlightOptions {
    /**
     * Style for highlighting found items
     */
    findHighlightStyle?: string;

    /**
     * Style for highlighting replacing items
     */
    replaceHighlightStyle?: string;
}
